import React from 'react'
import { Alert } from '@tabeo/scarf'

import PropTypes from 'prop-types'

function TicketError({ localUpdateError, ...rest }) {
  if (!localUpdateError) {
    return null
  }

  return (
    <Alert status="error" {...rest}>
      <Alert.Icon />
      There was an error, your changes were not saved.
    </Alert>
  )
}

TicketError.propTypes = {
  localUpdateError: PropTypes.any,
}

export default TicketError
